module.exports = __webpack_public_path__ + "img/PriceQuotations.823276a1.svg";